import React, { useState } from "react";

import {
  Typography,
  Box,
  Button,
  Card,
  InputLabel,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CardContent,
  CardHeader,
} from "@mui/material";

import ViewImageDialog from "./ViewImageDialog";

const Step3Component = ({
  trainerData,
  skillCenterCourseContents,
  styleClasses,
  grayedOutStyles,
  handleBack,
  handleNext,
}) => {
  const [viewImageDialogIsOpen, setViewImageDialogIsOpen] = useState(false);
  const [curImgMeta, setCurImgMeta] = useState({
    id: "",
    name: "",
  });

  function handleViewImage(imgMeta) {
    setCurImgMeta(imgMeta);
    setViewImageDialogIsOpen(true);
  }

  function closeViewImageDialog() {
    setViewImageDialogIsOpen(false);
  }

  return (
    <form style={styleClasses.formContainer}>
      <Typography variant="h6" style={styleClasses.sectionTitle}>
        Sections 6:
      </Typography>

      <Box style={styleClasses.labelContainer}>
        <InputLabel style={styleClasses.labelText}>
          Number of trainees that can per training session
        </InputLabel>
        <TextField
          variant="outlined"
          value={trainerData?.centerCapacity}
          style={grayedOutStyles}
          fullWidth
          readOnly
        />
      </Box>

      <Box style={styleClasses.labelContainer}>
        <InputLabel style={styleClasses.labelText}>
          Is located in a conducive environment? If yes, state justification. If
          no, state reason.
        </InputLabel>
        <TextField
          variant="outlined"
          value={trainerData?.commentOnConduciveness}
          style={grayedOutStyles}
          fullWidth
          readOnly
        />
      </Box>
      <Box style={styleClasses.labelContainer}>
        <InputLabel style={styleClasses.labelText}>
          How will your Centre resolve dispute and forestall future occurrences?
        </InputLabel>
        <TextField
          variant="outlined"
          value={trainerData?.commentOnDispute}
          style={grayedOutStyles}
          fullWidth
          readOnly
        />
      </Box>
      <Typography variant="h6" style={styleClasses.sectionTitle}>
        Section 7:
      </Typography>
      <Typography variant="subtitle1">
        a. Assessment of Course Content & Training Methodology
      </Typography>
      {/* Card Box with Course Details Table */}
      <Card
        style={{ marginTop: "24px", marginBottom: "50px", padding: "16px" }}
      >
        <Typography variant="h6">Course Details</Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Skill Area</TableCell>
                <TableCell>Total Duration (in days)</TableCell>
                <TableCell>Hours per Day</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {skillCenterCourseContents.map((course) => (
                <TableRow key={course.id}>
                  <TableCell>{course.skill.name}</TableCell>
                  <TableCell>{course.courseDuration}</TableCell>
                  <TableCell>{course.hoursPerDay}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      <Box style={styleClasses.labelContainer}>
        <InputLabel style={styleClasses.labelText}>
          {" "}
          b. Is training sufficient for a Corps member to start a business upon
          completion of the training? If yes state justification. If No state
          your reason{" "}
        </InputLabel>
        <TextField
          variant="outlined"
          value={trainerData?.commentOnImpact}
          style={grayedOutStyles}
          fullWidth
          readOnly
        />
      </Box>
      <Box style={styleClasses.labelContainer}>
        <InputLabel style={styleClasses.labelText}>
          {" "}
          c. Do you have a training curriculum for your skill areas(s)? If No
          why ?
        </InputLabel>
        <TextField
          variant="outlined"
          value={trainerData?.commentOnCurriculum}
          style={grayedOutStyles}
          fullWidth
          readOnly
        />
      </Box>

      <Typography variant="h6" style={styleClasses.sectionTitle}>
        Section 8:
      </Typography>

      <Card style={{ marginTop: "24px" }} elevation={0}>
        <CardHeader title="Uploaded Images" />
        <CardContent>
          {/* Uploaded images */}

          <ol>
            {trainerData.centerFiles &&
              trainerData.centerFiles.map((item) => (
                <li>
                  <Typography variant="body1">
                    {item.name}
                    <div
                      style={{
                        textDecoration: "underline",
                        display: "inline",
                        marginLeft: "5px",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        handleViewImage({
                          id: item.id,
                          name: item.name,
                        })
                      }
                    >
                      (View){" "}
                    </div>
                  </Typography>
                </li>
              ))}
          </ol>
        </CardContent>
      </Card>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "24px",
        }}
      >
        <Box style={{ marginTop: "24px" }}>
          <Button variant="outlined" color="primary" onClick={handleBack}>
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleNext}
            style={{ marginLeft: "16px" }}
          >
            Next
          </Button>
        </Box>
      </div>

      <ViewImageDialog
        closeHandler={closeViewImageDialog}
        isOpen={viewImageDialogIsOpen}
        imgMeta={curImgMeta}
      />
    </form>
  );
};

export default Step3Component;
